<template>
    <v-container>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <v-data-table v-else
            :items="records"
            :items-per-page="5"
            :footer-props="{ 'items-per-page-options': [10,20,50,-1] }"
            :headers="mainHeaders"
            item-key="FollowupRecordID"
            sort-by="FollowupRecordID"
            :sort-desc="true">

            <template v-slot:item.FollowupCreatedDate="{ item }">
                {{ item.FollowupCreatedDate | formatDateOnly }}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import medicalRecordAPI from '../../services/medicalRecordAPI';
import moment from 'moment';
import constants from 'comunet-btg-utah-repository-shared/constants';

export default {

     components: {

    },
    props: {
         medicalRecordID: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            loading: false,
            records: [],
            expanded: [],
            loadingError: "",

            mainHeaders: [
                {
                    text: "Change Made By",
                    value: "_LastModifiedEmail"
                },
                {
                    text: "Date",
                    value: "FollowupCreatedDate"
                },
                {
                    text: "Comment",
                    value: "FollowupChange"
                },
                { 
                    text: '', 
                    value: 'data-table-expand' 
                }
            ]
        };
    },
    filters: {
        // ensure data stored as a date only (ie no timezone) is formatted correctly
        formatDateOnly: function(value) {
            return moment.utc(value).format(constants.DATE_FORMAT_NO_TIME);
        }
    },
    computed:{
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        }
    },
    methods: {
        async loadFollowupChanges() {
            this.loading = true;
            this.loadingError = "";

            try {
                this.records = await medicalRecordAPI.getFollowupChanges(this.medicalRecordID);
                this.expanded = [ this.records[0] ]
            } catch (e) {
                this.loadingError = e.message
            }

            this.loading = false;
        },
},

async created() {
        await this.loadFollowupChanges();
},

}
</script>
